import axios from "axios";
import { Toast } from "vant";

const baseApi = '/api/v1'
// 获取请求域名
const baseUrl = process.env.NODE_ENV === 'local' ? baseApi : `${window.location.protocol}//${process.env.VUE_APP_CONFIG_URL}${baseApi}`


const instance = axios.create({
  baseURL: baseUrl,
  timeout: 10000,
});

// request 请求拦截器
instance.interceptors.request.use(
  (config) => {
    // const token = localStorage.getItem("token");
    // config.headers["os"] = 3; //外部h5
    // if (token) config.headers["Authorization"] = token;
    return config;
  },
  (err) => {
    return Promise.reject(err);
  }
);

// response 响应拦截器
instance.interceptors.response.use(
  ({ data }) => {
    const status = data.errorCode;
    // const login = sessionStorage.getItem("login");
    // 调用失败
    if (status === 400 || status === 401) {
      // localStorage.removeItem("token");
      return Promise.reject(data);
    } else if (status === 10000 || status === 200 || status === 201) {
      return data.data;
    } else {
      Toast.clear();
      Toast.fail(data.msg);
      return Promise.reject(data);
    }

    // return Promise.reject(data);
  },
  (err) => {
    Toast.clear();
    Toast.fail("网络请求超时");
    if (err.response) {
      switch (err.response.status) {
        case 500:
          break;
        default:
      }
    }

    return Promise.reject(err);
  }
);

// 设置 token
export const setToken = (token) => {
  instance.defaults.headers["Authorization"] = token;
};

export default instance;
